import React from 'react';
import { AdvertorialPage } from './pages/AdvertorialPage';
export function App() {
  return <AdvertorialPage data-id="element-0" />;
}